/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import RadarChart from './lib/radar-chart';
import * as d3 from 'd3';

export interface ScoresRadarChartScoresInterface {
  [key: string]: number
}

const ScoresRadarChart = (props: { scores: ScoresRadarChartScoresInterface, width: number, height: number, showMaterialityChart?: boolean } ) => {
  const chartId = props.showMaterialityChart ? 'sdgRadarChart' : 'materialityRadarChart';

  const data = [
    {
      name: 'Scores',
      axes: Object.keys(props.scores).map(label => ({
        axis: label, value: props.scores[label]
      }))
    }
  ];

  const maxValue = data[0].axes.reduce((acc, score) => score.value > acc ? score.value : acc, 0);

  const radarChartOptions = {
    w: props.width,
    h: props.height,
    margin: { top: 25, right: 30, bottom: 25, left: 30 },
    maxValue,
    levels: 4,
    roundStrokes: false,
    color: d3.scaleOrdinal<number, string>().range(['#2971e5']),
    format: '.0f',
    unit: '%',
    radialColor: d3.scaleOrdinal<number, string>().range(['#3bb05655', '#ffd700', '#ed1d2455',  '#ed1d24']),
    opacityCircles: 0.15
  };

  React.useEffect(() => {
    RadarChart(`#${chartId}`, data, radarChartOptions);
  });

  return <div id={chartId} style={{ display: 'inline-flex' }}></div>;
}

export default ScoresRadarChart;
